import { FC, SVGProps } from 'react'

export const Bookmark: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M6.75 3.5C6.41848 3.5 6.10054 3.6317 5.86612 3.86612C5.6317 4.10054 5.5 4.41848 5.5 4.75V19.5365L11.4146 16.5792C11.6257 16.4736 11.8743 16.4736 12.0854 16.5792L18 19.5365V4.75C18 4.41848 17.8683 4.10054 17.6339 3.86612C17.3995 3.6317 17.0815 3.5 16.75 3.5H6.75ZM4.80546 2.80546C5.32118 2.28973 6.02065 2 6.75 2H16.75C17.4793 2 18.1788 2.28973 18.6945 2.80546C19.2103 3.32118 19.5 4.02065 19.5 4.75V20.75C19.5 21.0099 19.3654 21.2513 19.1443 21.388C18.9232 21.5246 18.6471 21.5371 18.4146 21.4208L11.75 18.0885L5.08541 21.4208C4.85292 21.5371 4.57681 21.5246 4.3557 21.388C4.13459 21.2513 4 21.0099 4 20.75V4.75C4 4.02065 4.28973 3.32118 4.80546 2.80546Z"
			fill="currentColor"
		/>
	</svg>
)
